// Important: Keep in mind refactoring these routes will not apply renaming to html files where they are used.
// Use a replace in the solution to make those changes manually.
export class NavRoutes {
    
    public static readonly Root: string = '';
    public static readonly Contact: string = 'contact';
    public static readonly SignUp: string = 'sign-up';
    public static readonly Login: string = 'employee-login';

    // Anonymous stand alone pages routes
    public static readonly VerifyAccount: string = 'verify-account';
    public static readonly VerifyEmail: string = 'verify-email';
    public static readonly ForgotPassword: string = 'forgot-password';
    public static readonly ResetPassword: string = 'reset-password';

    // Authorized user Website routes
    public static readonly AddEmployee: string = 'add-employee';
    public static readonly EditEmployee: string = 'edit-employee';
    public static readonly AddInventory: string = 'add-inventory';
    public static readonly ChangePassword: string = 'change-password';
    public static readonly ChangeEmail: string = 'change-email';
    public static readonly Dashboard: string = 'dashboard';
    public static readonly TransactionHistory: string = 'transaction-history';
    public static readonly Products: string = 'product-management';
    public static readonly FoodSources: string = 'food-source-management';
    public static readonly Agencies: string = 'agency-management';
    public static readonly Employees: string = 'employee-management';
    public static readonly Account: string = 'account-settings';
    public static readonly Inquiries: string = 'inquiry';
    public static readonly ReferenceNumbers: string = 'reference-numbers';

    // Authorized user Kiosk routes
    public static readonly Kiosk: string = 'kiosk';
    public static readonly KioskOptions: string = 'options';

    // Authorized user Website/Kiosk routes
    public static readonly InventoryOptions: string = 'inventory-options';
    public static readonly Transaction: string = 'transaction';
    
    // Error routes
    public static readonly Error: string = 'error';
}
